import { useTranslation } from 'react-i18next';
import { Link } from 'wouter';
import { ChevronRight, Package, Users } from 'lucide-react';
import { SettingsCard } from './primitives';
import type { BookingPageAdmin } from '../api';

export function FromAccountCard({ counts }: { counts: BookingPageAdmin['counts'] }) {
  const { t } = useTranslation('adminBookingPage');
  const rows = [
    { href: '/admin/services', icon: Package, title: t('fromAccount.services', { active: counts.services_active, total: counts.services_total }), hint: t('fromAccount.servicesHint'), action: t('fromAccount.manageServices') },
    { href: '/admin/team', icon: Users, title: t('fromAccount.team', { count: counts.providers_active }), hint: t('fromAccount.teamHint'), action: t('fromAccount.manageTeam') },
  ];
  return (
    <SettingsCard title={t('fromAccount.title')} description={t('fromAccount.description')} testId="from-account-card">
      <div className="flex flex-col">
        {rows.map((row, i) => (
          <Link
            key={row.href}
            href={row.href}
            className={`flex min-h-[44px] items-center gap-3.5 py-3.5 ${i > 0 ? 'border-t border-line' : ''}`}
          >
            <span className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-brand-50">
              <row.icon className="h-[18px] w-[18px] text-brand-600" />
            </span>
            <span className="flex flex-1 flex-col gap-0.5">
              <span className="text-[15px] font-semibold text-ink">{row.title}</span>
              <span className="text-body-sm text-soft">{row.hint}</span>
            </span>
            <span className="hidden items-center gap-1 text-body font-medium text-brand-500 sm:inline-flex">{row.action}</span>
            <ChevronRight className="h-[18px] w-[18px] text-text-muted" />
          </Link>
        ))}
      </div>
    </SettingsCard>
  );
}
